import React from 'react';
import {Button} from "antd";
import classes from "./buttons.module.css";

const GreenLightButton = (props) => {
    return (
        <Button {...props} className={classes.greenLightButton}>
            <span>{props.children}</span>
        </Button>
    );
};

GreenLightButton.propTypes = {
    ...Button.propTypes, // Use Ant Design Button propTypes
};

export default GreenLightButton;